import React, { memo } from 'react'
import MediaQueryMatch from '@pcln/media-query-match'
import ResponsiveContext from '../../contexts/ResponsiveContext'

function WithResponsive (LargeComponent, SmallComponent) {
  return memo(function withResponsive (props) {
    let other = {}
    if (typeof window === 'undefined') {
      if (props.isMobile) {
        other.device = { width: 600 }
      } else {
        other.device = { width: 1600 }
      }
    }

    return (
      <ResponsiveContext.Consumer>
        {context => (
          <React.Fragment>
            <MediaQueryMatch
              minWidth={context.smallMinBreakpoint}
              maxWidth={context.largeMinBreakpoint}
              {...other}
            >
              <SmallComponent {...props} />
            </MediaQueryMatch>
            <MediaQueryMatch minWidth={context.largeMinBreakpoint} {...other}>
              <LargeComponent {...props} />
            </MediaQueryMatch>
          </React.Fragment>
        )}
      </ResponsiveContext.Consumer>
    )
  })
}

export default WithResponsive
